import React from 'react';
import { eventData } from '../mockData';
import ModalNav from './ModalNav';

const InspirationContent = () => {
  return (
    <div>
      <ModalNav active="inspiration" />
      <div className="py-10 px-6 md:px-10">
      {/* Header */}
      <div className="text-center mb-12">
        <p className="text-sm md:text-base uppercase tracking-[0.4em] text-orange-500/80 font-bold mb-3">
          ⚠ No Black Tie ⚠
        </p>
        <h2 className="text-4xl md:text-6xl font-black mb-4 text-transparent bg-clip-text bg-gradient-to-r from-orange-400 via-amber-500 to-orange-600">
          Dress Code
        </h2>
      </div>

      {/* Gallery Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {eventData.images.gallery.map((image, index) =>
        <div
          key={index}
          data-testid={`inspiration-image-${index}`}
          className="group relative overflow-hidden rounded-xl border-2 border-orange-600/30 hover:border-orange-500 transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:shadow-orange-500/50">

            <div className="aspect-square overflow-hidden">
              <img
              src={image.url}
              alt={image.caption || `Inspiration ${index + 1}`}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
            </div>
          </div>
        )}
      </div>

      {/* Heels warning */}
      <div className="mt-12 max-w-3xl mx-auto bg-gradient-to-r from-orange-900/40 via-red-900/30 to-orange-900/40 backdrop-blur-sm border-2 border-orange-500/50 rounded-xl p-6 md:p-8">
        <div className="flex items-start gap-4">
          <div className="text-4xl flex-shrink-0">👢</div>
          <div>
            <h3 className="text-xl md:text-2xl font-bold text-orange-300 mb-2 uppercase tracking-wide">
              Pas de talons aiguilles
            </h3>
            <p className="text-gray-200 text-base md:text-lg leading-relaxed">
              Favorisez des <span className="text-orange-400 font-semibold">chaussures robustes</span> pour tenir toute la nuit. 🔥
            </p>
          </div>
        </div>
      </div>
      </div>
    </div>);

};

export default InspirationContent;